<template>
    <div class="list-header mb-5 clearfix">
        <span class="title  float-left">{{title}}</span>
    </div>
</template>
<script>
  export default {
    props: {
      title: String
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Common/ListHeaderTitle.vue